export function formatTeamYardsInText(originalText = '') {
	const teamYardageTexts = originalText.match(/[a-zA-Z]+[0-9]+/gm) || [];
	if (!teamYardageTexts.length) {
		return originalText;
	}

	teamYardageTexts.forEach(teamYardage => {
		const teamTricode = (teamYardage.match(/[a-zA-Z]+/g)[0] || '').toUpperCase();
		const teamYards = teamYardage.match(/[0-9]+/g)[0] || '';
		originalText = originalText.replace(teamYardage, `${teamTricode} ${teamYards}`);
	});

	return originalText;
}

export function shortenPlayerNames(originalText, players = []) {
	let newText = originalText;

	if (!players.length) {
		return originalText;
	}

	for (const player of players) {
		const textToReplace = `${player.first_name} ${player.last_name}`;
		const playerInitial = player.first_name.charAt(0);
		const replacementText = `<b>${playerInitial}. ${player.last_name}</b>`;

		newText = newText.replace(textToReplace, replacementText);
	}
	return newText;
}

export function getPlayColor(play) {
	const darkBlue = 'darkBlue';
	const red = 'red';
	const grey = 'grey';
	const brightBlue = 'brightBlue';

	const playColorMap = new Map([
		['extra_point_attempt good', brightBlue],
		['two_point_attempt good', brightBlue],
		['extra_point_attempt no good', red],
		['field_goal no good', red],
		['two_point_attempt no good', red],
		['safety', red],
		// ['rush tackled', red],
		['two_minute_warning', grey],
		['period_end', grey],
		['timeout', grey],
		['tv_timeout', grey],
		['kick_off', grey],
		['kick_off_return', grey],
		['onside_kick_off', grey],
	]);

	return playColorMap.has(play.play_type) ? playColorMap.get(play.play_type) : darkBlue;
}
